import {
  LayoutGrid,
  Users,
  IdCard,
  ListOrdered,
  RotateCcw,
  FileText,
  Folder,
  ArrowUpDown,
  Bell,
  Vault,
} from "lucide-react";

const ICON_SIZE = 18;

export const TellerMenuList = [
  {
    title: "Cash",
    iconStyle: <LayoutGrid size={ICON_SIZE} />,
    to: "/cash",
  },
  {
    title: "Customers",
    iconStyle: <Users size={ICON_SIZE} />,
    to: "/customers",
  },
  {
    title: "Beneficiaries",
    iconStyle: <IdCard size={ICON_SIZE} />,
    to: "/beneficiaries",
  },
  {
    title: "Transactions",
    iconStyle: <ListOrdered size={ICON_SIZE} />,
    to: "/transactions",
  },
  {
    title: "Refunds",
    iconStyle: <RotateCcw size={ICON_SIZE} />,
    to: "/refunds",
  },
  {
    title: "Requests",
    iconStyle: <FileText size={ICON_SIZE} />,
    to: "/requests",
  },
  {
    title: "Report",
    iconStyle: <Folder size={ICON_SIZE} />,
    to: "/report",
  },
  {
    title: "Top-up - Withdraw",
    iconStyle: <ArrowUpDown size={ICON_SIZE} />,
    to: "/topup-withdraw",
  },
  {
    title: "Notifications",
    iconStyle: <Bell size={ICON_SIZE} />,
    to: "/notifications",
  },
];

export const VaultManagerMenuList = [
  {
    title: "Cash",
    iconStyle: <LayoutGrid size={ICON_SIZE} />,
    to: "/cash",
  },
  {
    title: "Cash Vault",
    iconStyle: <Vault size={ICON_SIZE} />,
    to: "/cash-vault-management",
  },
  {
    title: "Requests",
    iconStyle: <FileText size={ICON_SIZE} />,
    to: "/requests",
    badge: "2",
    badgeColor: "#00234B",
  },
  {
    title: "Report",
    iconStyle: <Folder size={ICON_SIZE} />,
    to: "/report",
  },
  {
    title: "Notifications",
    iconStyle: <Bell size={ICON_SIZE} />,
    to: "/notifications",
    badge: "2",
    badgeColor: "#E50F38",
  },
];

export const SupervisorMenuList = [
  {
    title: "Cashier",
    iconStyle: <LayoutGrid size={ICON_SIZE} />,
    to: "/cashier-management",
  },
  {
    title: "Transactions",
    iconStyle: <ListOrdered size={ICON_SIZE} />,
    to: "/transactions",
  },
  {
    title: "Requests",
    iconStyle: <FileText size={ICON_SIZE} />,
    to: "/requests",
    badge: "1",
    badgeColor: "#00234B",
  },
  {
    title: "Report",
    iconStyle: <Folder size={ICON_SIZE} />,
    to: "/report",
  },
  {
    title: "Notifications",
    iconStyle: <Bell size={ICON_SIZE} />,
    to: "/notifications",
  },
];

const userRole = localStorage.getItem("userRole");
export const MenuList =
  userRole === "Vault Manager"
    ? VaultManagerMenuList
    : userRole === "Supervisor"
    ? SupervisorMenuList
    : TellerMenuList;
